import { render, staticRenderFns } from "./MapZone.vue?vue&type=template&id=bed6af06"
import script from "./MapZone.vue?vue&type=script&lang=js"
export * from "./MapZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports